import React from "react"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"

import { ICheckListViewActions, IChecklistViewFinding } from "../.."
import ContextMenu from "../ContextMenu"

import ActionList from "./ActionList"

export interface Props extends IChecklistViewFinding {
    contextMenuActions: ICheckListViewActions
}

export const Finding = ({
    actions,
    id,
    label,
    title,
    url,
    controls,
    contextMenuActions,
}: Props): JSX.Element => {
    return (
        <div
            className="theme-thumb bg-cloud theme-thumb--normalAlignment tw-flex-col has-hidden-actions tw-mx-0 tw-my-1 tw-px-2"
            data-ft-component="finding"
            data-ft-id={id}
            data-ft-title={title}
        >
            <div className="tw-flex">
                <div className="tw-flex tw-flex-col tw-flex-1 tw-px-2">
                    <div data-ft-component="label" className="label is-dimmed">
                        {label}
                    </div>

                    <span data-ft-component="title">{title}</span>
                </div>

                <aside className="tw-content-center">
                    <ActionAnchor
                        actionType={ActionType.icon}
                        extraClasses="is-hidden-action"
                        data-ft-component="goToLink"
                        href={url}
                        title={title}
                    >
                        {Symbols.ArrowForward}
                    </ActionAnchor>

                    <ContextMenu
                        type="Finding"
                        resourceId={id}
                        controls={controls}
                        contextMenuActions={contextMenuActions}
                        remark=""
                    />
                </aside>
            </div>

            <ActionList
                actions={actions}
                containerElement="findingActionsContainer"
                isLabelShown={false}
            />
        </div>
    )
}

export default Finding
